import variables from '@styles/variables';

export default variables.searchHeaderHeight;
